import React from "react";
import {
  // Space,
  Row,
  Col,
} from "antd";
// import { FORM } from "../../Constants/doctor";
import medicine from "../../Assets/Images/clinica-prime-logo-dark.png";

const FormHeader = () => {
  return (
    <div>
      <Row>
        <Col
          span={24}
          align="center"
          // className="form-header"
        >
          <img src={medicine} className="header-logo" alt="logo" />
        </Col>
      </Row>
      {/* <Row>
                <Col 
                span={24} 
                align='center' 
                className="form-presc"
                >
                {FORM.header2}
                </Col>
            </Row> */}
      {/* <Row className='mt-2'>
                {FORM.headerColumns.map((column, index) => (
                <Col span={24} key={index} align='center'>
                    <Space direction="vertical">
                    <strong>{column.doc1}</strong>
                    <div>
                        {column.value.map((value, innerIndex) => (
                        <div key={innerIndex}>{value}</div>
                        ))}
                    </div>
                    </Space>
                </Col>
                ))}
            </Row> */}
      <Row>
        <Col span={24}>
          <hr className="hr-class" />
        </Col>
      </Row>
    </div>
  );
};

export default FormHeader;
